import { useState } from 'react'
import { CodeReveal } from '../ui/CodeReveal'

/**
 * Erfolgs-Ansicht für einen frisch ausgestellten Chef-Aktivierungscode (Werkstatt-Anlage ODER Re-Issue): zeigt den
 * Code UND einen fertigen Magic-Link zum Weiterschicken — beides kopierbar. Der Chef öffnet den Link (oder tippt den
 * Code auf /aktivieren) und setzt sein Passwort selbst. Der Klartext ist nur EINMAL sichtbar.
 */
export function ChefActivationReveal({
  code,
  chefUsername,
  heading,
}: {
  code: string
  chefUsername?: string | null
  heading: string
}) {
  const link = `${window.location.origin}/aktivieren?code=${encodeURIComponent(code)}`
  const [copied, setCopied] = useState(false)
  function copyLink() {
    void navigator.clipboard?.writeText(link).then(
      () => setCopied(true),
      () => setCopied(false),
    )
  }
  return (
    <div className="wf-activation">
      <p className="wf-activation__title">
        {heading}
        {chefUsername ? ` — Chef-Login: ${chefUsername}` : ''}
      </p>
      <p className="hint">
        Der Chef setzt sein Passwort selbst. Schick ihm den Link oder den Code — 72 Stunden gültig, danach hier neu
        ausstellbar. Ein zuvor ausgegebener Code ist jetzt ungültig.
      </p>
      <CodeReveal code={code} hint="Chef-Aktivierungscode." />
      <div className="wf-card wf-codereveal">
        <code className="wf-code wf-code--link">{link}</code>
        <button type="button" className="wf-btn wf-btn--sm" onClick={copyLink}>
          {copied ? 'Kopiert ✓' : 'Link kopieren'}
        </button>
        <p className="hint">Magic-Link: öffnet die Aktivierungsseite mit vorausgefülltem Code.</p>
      </div>
    </div>
  )
}
